import React, { useEffect
  // , useState
 } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import '../Licitaciones2018/style.css'
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
// import ModalConvocatoria from '../Modal/ModalConvocatoria.js';

const Inicio = () => {

  // const [isModalOpen, setModalOpen] = useState (true);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  // const closeModal = () => {
  //   setModalOpen(false);
  //   };
  return (
    <>
      <Carousel />
      <div className='container'>
        <div className='row'>
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Infraestructura.svg")` }}>

            </div>
          </div>
          <div className='secretaria_name'>
            <h1>SECRETARÍA DE INFRAESTRUCTURA PÚBLICA Y DESARROLLO URBANO SOSTENIBLE</h1>
          </div>

          {/*<a className='obrasMpios' href='http://innovacion-sopot.hidalgo.gob.mx/view/public/?controller=sopot_works&view=works_by_year'>*/}

          {/*</a>*/}

          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob' />
            <p>Proyectar, construir, reconstruir, ampliar, modernizar, operar, administrar, explotar, rehabilitar, y conservar por sí o por terceros, mediante financiamiento del Estado o de particulares las carreteras libres o de cuota, caminos, puentes e infraestructura de competencia estatal.<br></br><br></br>Ejecutar y supervisar, directamente o por contrato con particulares, las obras públicas del Gobierno del Estado, de la Federación o de los Ayuntamientos, que le sean encomendadas.<br></br><br></br>Construir y conservar por sí misma y con la cooperación que se acuerde con el Gobierno Federal, las carreteras, caminos, puentes, centrales de autotransporte, aeropuertos e infraestructura estatal.</p>
            <a className='verMas' href='./Funciones/Funciones'>Ver mas</a>
            <div className='btn_organigrama'>
              <Link to='/Transparencia/Rubros/DetalleRubro/2. Estructura' className="btn btn-primary btnHome">Organigrama</Link>
              <Link to='/Transparencia/Rubros/DetalleRubro/1. Normatividad' className="btn btn-primary btnHome">Normatividad</Link>
            </div>
            <div className='secretaria-redes'>
                <a href='https://www.facebook.com/SIPDUS' target='_blank'>
                  <i className='social-network icon-fb-light'></i>
                </a>
              <a href='https://twitter.com/SIPDUS' target='_blank'>
                <i className='social-network icon-x-light'></i>
              </a>
              <a href='https://www.instagram.com/infraestructura_hidalgo/' target='_blank'>
                <i className='social-network icon-instagram-light'></i>
              </a>
            </div>
          </div>
        </div>
        <UltimasNoticias/>
        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
            <hr className='hr-gob' />
          </div>
          <div className='section_notes'>
            {
              titular.map((item, index) => (
                <>
                  <div key={index} className='sec_photo'>
                    <div className='img_secretario' style={{ backgroundImage: `url("${item.imagen}")` }}>
                    </div>
                  </div>
                  <div className='sec_container'>
                    <div className='sec_name'>
                      {/* <h3>{item.nombre}</h3> */}
                    </div>
                    <div className='sec_function'>
                      <h4>Función del Secretario</h4>
                      <p>{item.funcion} </p>
                      <p>{item.funcion2} </p>
                      <p>{item.funcion3} <a href='./Funciones/Funciones'>Ver mas</a> </p>

                      <div className='btn_agenda'>
                        <Link to="Agenda">Conoce la agenda del Secretario</Link>
                      </div>
                    </div>
                  </div>
                </>
              ))
            }
          </div>
        </div>

            {/* <ModalConvocatoria isOpen={isModalOpen} onClose={closeModal} /> */}

        <div className='row'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob' />
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d695.0461906377934!2d-98.76930681177983!3d20.092182236081797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a0be33dae639%3A0x5f22bc49c5d6c7a2!2sSecretaria+de+Infraestructura+Pública+y+Desarrollo+Urbano+Sustentable+(SIPDUS)!5e0!3m2!1ses!2smx!4v1543280341462"
              width="100%"
              height="300"
              frameborder="0"
              style={{ border: 0, marginBottom: 50 }}
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </>
  )
}

export default Inicio